module.exports = __webpack_public_path__ + "static/media/background.1d457410.mp4";